<template>
  <div v-if="$store.getters.isLogin">
    <div class="d-inline-flex position-fixed align-items-center" id="version">
      <div class="bg-danger text-white rounded px-1 font-weight-bold" style="font-size: 0.8rem;">
        V {{version}}
      </div>
      <b-button size="sm" class="py-0 px-1 ml-1" v-on:click="showAdmin = !showAdmin" v-if="1 !== 1">
        <i class="far fa-paper-plane"></i>
      </b-button>
      <div class="mx-2 d-none d-md-block" v-if="showLogSwitch">
        <b-form-checkbox name="check-button" v-model.lazy="surveyLogTF" switch size="sm">
        </b-form-checkbox>
      </div>
    </div>
    <div v-if="showAdmin" class="position-fixed d-flex flex-column justify-content-start align-items-stretch" id="send-to-admin">
      <div class="pt-1 pr-1 text-right " >
        <b-button v-on:click="showAdmin = false" variant="danger">
          <i class="fas fa-times-circle"></i>
        </b-button>
      </div>
      <div class="flex-grow-1 m-4 p-4 bg-light rounded">
        <h5>Send a message to the administrator</h5>
        <b-form>
          <b-textarea rows="20" v-model="message" :disabled="disabled"></b-textarea>
        </b-form>
        <div class="mt-4 text-right">
          <b-button block :disabled="!message.length || disabled" v-on:click="sendToAdmin">
            <i class="fas fa-envelope-square"></i>
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="surveyLogTF && logs.length" class="d-none d-sm-inline-flex align-items-center position-fixed" id="survey-logs">
      <div class="bg-white rounded p-1 shadow-sm">
        <div v-for="(log, idx) in logs" v-bind:key="`survey-logs-${idx}`">
          <JoinLog :log="log" :class="[idx === 0 ? 'bg-light' : 'bg-transparent']"></JoinLog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JoinLog from '@/components/surveyJoinLog'
import Version from '@/version.js'
export default {
  name: 'global-footer',
  components: {
    JoinLog
  },
  data: () => ({
    showAdmin: false,
    message: '',
    disabled: false,
    surveyLogTF: false,
    version: Version
  }),
  created () {
    this.surveyLogTF = this.$store.getters.surveyLogTF
  },
  methods: {
    async sendToAdmin () {
      this.disabled = true
      try {
      } catch (e) {
      }
    }
  },
  sockets: {
    'specificMessageSendForSurvey' (data) {
      console.log(data)
      // this.$store.dispatch('surveyLogPush', data)
    }
  },
  computed: {
    logs () {
      return this.$store.getters.lastSurveyLogs.map(d => d)
    },
    showLogSwitch () {
      return this.$store.getters.user.auth
    }
  },
  watch: {
    surveyLogTF (val) {
      this.$store.dispatch('surveyLogToggle', val)
    }
  }
}
</script>

<style scoped>
  div#version {
    bottom: 0;
    left: 0;
    padding: 0.2rem;
    z-index: 2;
  }
  div#send-to-admin {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(0,0,0, 0.5);
  }
  div#survey-logs {
    right: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue